module.exports = __webpack_public_path__ + "img/PositiveMedia-logo.5494e7ba.png";